import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { commissionApi } from "@/api/commission.api";
import { queryKeys } from "@/utils/queryKeys";

export function useCommissionOverview(params?: { from?: string; to?: string }) {
  return useQuery({
    queryKey: queryKeys.commission.overview(params),
    queryFn: () => commissionApi.getOverview(params),
  });
}

export function useCommissionSettings() {
  return useQuery({
    queryKey: queryKeys.commission.settings(),
    queryFn: () => commissionApi.getSettings(),
  });
}

export function useUpdateCommissionSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: commissionApi.updateSettings,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["commission"] }),
  });
}
